import { put, select } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCTS_FAILURE,
} from 'src/pages/scheduleSurgery/redux/actions';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    convertObjectToQueryParams,
    updateIsAllTerritoryId,
} from 'src/utils/util';

export default function* searchProducts() {
    let url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/productList?`;
    const { queryParams, territoryId, isUHOrder } = yield select((state) => ({
        queryParams: state.productsSearchReducer.queryParams,
        territoryId: state.productsSearchReducer.queryParams?.usageTerritoryId
            ? state.productsSearchReducer.queryParams.usageTerritoryId
            : state.surgeryReducer.surgeryDetails.territoryId,
        isUHOrder: state.surgeryDetailsReducer?.surgeryData?.surgeryDetails?.isSEorUH
    }));
    const { isMastOrder } = yield select((state) => ({
        isMastOrder: state.loginReducer.isMastOrder
    }));
    const { isMastOrderTemplate } = yield select((state) => ({
        isMastOrderTemplate: state.commonTemplateReducer.isMastOrderTemplate
    }));
    const token = queryParams.cancelSearchToken;
    delete queryParams.cancelSearchToken;
    delete queryParams.usageTerritoryId;
    if (queryParams)
        url = `${url}${convertObjectToQueryParams({
            ...queryParams,
            territoryId: updateIsAllTerritoryId(territoryId),
            isMastOrder:isMastOrder||isMastOrderTemplate,
        })}&uhOrder=${isUHOrder ? isUHOrder : false}`;

    try {
        const result = yield axios
            .get(url, { cancelToken: token })
            .then((response) => response.data);
        yield put({
            type: GET_PRODUCTS_SUCCESS,
            products: result.productsList || [],
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
            totalRecordsCount: result.productsTotalCount,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url
        });
        yield put({
            type: GET_PRODUCTS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
